import moment from 'moment';

class CreateSubcontractModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http) {
    "ngInject";
    this.name = 'CreateSubcontractModal';

    $scope.subcontract = {
      'number': '',
      'description' : '',
      'contractType': 0,
      'associatedContract': 0
    };

    $http.get($rootScope.apiHost+'/api/admin/contracts?activeOnly=true&allowSubcontracting=true', {withCredentials: true}).then(function (success) {
      $scope.contractOptions = success.data;
    });


    let self = this;
    $scope.addSubcontract = function () {
      $uibModalInstance.success($scope.subcontract);
    }
  }
}

export default CreateSubcontractModalController;



// WEBPACK FOOTER //
// ./client/common/modals/createSubcontractModal/createSubcontractModal.controller.js